<template>
  <div id="myCarousel" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
      <li data-target="#myCarousel" :data-slide-to='index' v-for='(slide, index) in slides' :key='slide.id' :class="index == 0 ? 'active' : ''"></li>
    </ol>
    <div class="carousel-inner">

      <div class="carousel-item" v-for='(slide, index) in slides' :key='slide.id' :class="index == 0 ? 'active' : ''">
        <img class="w-100" :src='slide.img' :alt='slide.caption_title'>
        <div class="container">
          <div class="carousel-caption text-left with-top-padding caption-bg">
            <h1>{{ slide.caption_title }}</h1>
            <p v-if='slide.caption_description'>{{ slide.caption_description }}</p>
            <ul v-if='slide.caption_list'>
              <li v-for='(item_list, i) in getVisibleItems(slide.caption_list)' :key='i'>
                <span :class="item_list.type === 'lead' ? 'lead-text' : ''">
                  {{ item_list.text }}
                </span>
              </li>
            </ul>

            <router-link class="btn btn-purple" v-if='slide.link' :to='slide.link'>Подробнее</router-link>
            <a class="btn btn-purple" v-else-if='slide.externalLink && !slide.buttonText' :href='slide.externalLink' target="_blank">Подробнее</a>
            <a class="btn btn-purple" v-else-if='slide.externalLink && slide.buttonText' :href='slide.externalLink'>{{ slide.buttonText }}</a>
          </div>
        </div>
      </div>

      <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  data () {
    return {
      slides: [
        {
          caption_title: 'Скажи-ка по-SuiteCRM-овски?',
          caption_list: [
            { text: 'SuiteCRM — не коробка. А коробка с инструментом.', type: 'lead' },
            { text: 'App321 и Camunda внутри — без прикрас. Если легаси, мы не пугаемся.' },
            { text: 'CRM — это не “воронка”. Это: кто с кем говорит и зачем.' },
            { text: 'Контур.Фокус встроен: ЕГРЮЛ, финансы, связи. Без Excel. Без копипаста.' },
            { text: 'Интеграции — не “подключаем всё”, а “убираем всё лишнее”.' },
            { text: 'SuiteCRM: звучит надёжно. Работает и не мешает работать людям.' }
          ],
          img: '/static/img/carousel/1.jpg',
          link: '/products/suitecrm'
        },
        {
          caption_title: 'Скажи-ка по-Ватермановски?',
          caption_list: [
            { text: 'Биллинг — как насос. Качаешь одно, а жалуются на другое.', type: 'lead' },
            { text: '🧱 Инженерно: счётчики, насосы, интерфейсы. Всё должно замкнуться.' },
            { text: '🤝 По-человечески: если платёжка не пришла — значит, кто-то забыл поговорить.' },
            { text: '💡 По-BizOpsDev-ски: система жива, пока её понимает команда. И подрядчик.' },
            { text: '🌨 По-Омски: зима суровая, но серверной хорошо. Всё держится на кодах321.' },
            { text: 'Работаем в Омском водоканале. И в ГК Росводоканал.' }
          ],
          img: '/static/img/carousel/2.jpg',
          link: 'products/waterman3'
        },
        {
          caption_title: 'Поговорим по-бизнесовому?',
          caption_list: [
            { text: 'Без шоу. Без витрины. Без нужды понравиться.', type: 'lead' },
            { text: 'Как те, кто управляют организациями.', type: 'lead' },
            { text: 'Если надо продавать — нам не по пути. Мы не продаём. Мы входим, если есть с кем идти.' },
            { text: 'Знаем, как звучат мёртвые команды. И знаем, когда ещё можно оживить.' },
            { text: 'Хотите просто поговорить — поговорим. Хватит — отлично. Надо продолжить — включимся.' }
          ],
          img: '/static/bsa-grey.jpg',
          externalLink: 'mailto:pp@lab321.ru',
          buttonText: 'Просто поговорить'
        }
      ]
    }
  },
  methods: {
    getVisibleItems(list) {
      if (window.innerWidth < 576) {
        return list.slice(0, 2); // Только 2 строки на мобильных
      }
      return list; // Полный список на десктопе
    }
  }
}
</script>

<style scoped>
@media (max-width: 575.98px) {
  h1 {
    font-size: 1.5em;
    line-height: 1.2em;
    margin-bottom: 0.6em;
  }

  .carousel-item img {
    min-height: 550px;
    object-fit: cover;
  }

  .carousel-caption {
    font-size: 0.9em;
    line-height: 1.4em;
    padding: 2.5em 1em 2em 1em;
  }

  .carousel-caption ul li {
    margin-bottom: 0.5em;
  }

  .lead-text {
    font-size: 1.1em;
    font-weight: bold;
  }
}

.lead-text {
  font-size: 1.25em;
  font-weight: bold;
}

.with-top-padding {
  padding-top: 4.5em; /* для меню из двух строк */
}

.caption-bg {
  background-color: rgba(0, 0, 0, 0.5); /* тёмная подложка */
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/Carousel.vue